import HTTPServices from "../HTTPServices/httpService";

const customerServices = {
  //(1)
  searchNameOrPhone: async function (searchWord) {
    console.log("'customerServices' service called: searchword: " + searchWord);
    return await HTTPServices.post("customer/searchNameOrPhone", searchWord);
    // let result =await HTTPServices.post("customer/searchNameOrPhone", searchWord);

    // debugger;
    // console.log('retrun result --->'+ result);
    // return result;
  },

  searchByOrderNumber: async function (searchWord) {
    console.log("'orderServices' service called: searchword: " + searchWord);
    return await HTTPServices.post(
      "order/GetCustomerDetailsAndOrdersByOrderID",
      searchWord
    );
  },

  searchByTrackingNumber: async function (searchWord) {
    console.log("'orderServices' service called: searchword: " + searchWord);
    return await HTTPServices.post(
      "order/GetCustomerDetailsAndOrdersByTrackingNo",
      searchWord
    );
  },

  //(2)
  save: async function (customerObj) {
    console.log("'customerServices' service called: save : " + customerObj);
    let customer = await HTTPServices.post("customer/save", customerObj);
    // customer.then((result) => {
    //   debugger;
    //   console.log("Promised result: " + result); // "Some desired value"
    //   return result;
    // });

    return customer;
  },

  searchByCustomerGUID: async function (customerGUID) {
    console.log(
      "'customerServices' service called: searchByCustomerGUID: " + customerGUID
    );
    let customerGot = await HTTPServices.get(
      "customer/getByID/" + customerGUID
    );
    console.log("result got: " + customerGot?.name);
    return customerGot;
  },
  //(3)
  // getOrderVMByCustomerID: async function (customerID) {
  //   console.log(
  //     "'getOrderVMByCustomerID' service called: customerID: " + customerID
  //   );
  //   let result = await HTTPServices.post(
  //     "customer/GetOrderVMByCustomerID",
  //     customerID
  //   );
  //   debugger;
  //   console.log("retrun result --->" + result);
  //   return result;
  // },
};

export default customerServices;

// {
//   email: "email",
//   password: "passwoard",
// }

//   // POST request using fetch inside useEffect React hook
//   const requestOptions = {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ title: 'React Hooks POST Request Example' })
// };
// fetch('https://reqres.in/api/posts', requestOptions)
//     .then(response => response.json())
//     .then(data => setPostId(data.id));
